import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _BookLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsxs("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: [_jsx("path", { stroke: "currentColor", d: "M20 12v5c0 1.886 0 2.828-.586 3.414S17.886 21 16 21H6.5A2.5 2.5 0 0 1 4 18.5M20 12V7c0-1.886 0-2.828-.586-3.414S17.886 3 16 3H8c-1.886 0-2.828 0-3.414.586S4 5.114 4 7v11.5M20 12c0 1.886 0 2.828-.586 3.414S17.886 16 16 16H6.5A2.5 2.5 0 0 0 4 18.5" }), _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M9 8h6" })] }) });
}
const BookLight = forwardRef(_BookLight);
export { BookLight };
